import { UAParser } from "ua-parser-js";

export const checkIsMobile = () => ["mobile", "tablet"].includes(new UAParser().getDevice().type);
